import { createHook, createStore } from "react-sweet-state";

interface HelperStoreState {
    goNextInterrupt: (() => void) | undefined;
    goPrevInterrupt: (() => void) | undefined;
}

const initialState: HelperStoreState = {
    goNextInterrupt: undefined,
    goPrevInterrupt: undefined,
};

const assessmentHelperStore = createStore({
    initialState,
    actions: {
        setGoNextInterrupt: (value: () => void) => ({ setState }) => {
            setState({ goNextInterrupt: value });
        },
        clearGoNextInterrupt: () => ({ setState }) => {
            setState({ goNextInterrupt: undefined });
        },
        setGoPrevInterrupt: (value: () => void) => ({ setState }) => {
            setState({ goPrevInterrupt: value });
        },
        clearGoPrevInterrupt: () => ({ setState }) => {
            setState({ goPrevInterrupt: undefined });
        },
        clearInterupts: () => ({ setState }) => {
            setState({
                goPrevInterrupt: undefined,
                goNextInterrupt: undefined,
            });
        },
    },
});

export const useInterrupts = createHook(assessmentHelperStore, {
    selector: ({ goNextInterrupt, goPrevInterrupt }) => ({
        goNextInterrupt,
        goPrevInterrupt,
    }),
});

export const useAssessmentHelperStoreActionsInner = createHook(assessmentHelperStore, {
    selector: undefined,
});

export const useAssessmentHelperStoreActions = () => {
    const [, actions] = useAssessmentHelperStoreActionsInner();
    return actions;
};
